import React, { useEffect } from 'react';
import HeroSection from '../components/home/HeroSection/HeroSection';
import ServicesSection from '../components/home/ServicesSection/ServicesSection';
import HowItWorks from '../components/home/HowItWorks/HowItWorks';
import Testimonials from '../components/home/Testimonials/Testimonials';

const Home = () => {
  useEffect(() => {
    document.title = 'NEST | Home';
  }, []);
  return (
    <div>
      <HeroSection />
      <ServicesSection />
      <HowItWorks />
      <Testimonials />
    </div>
  );
};

export default Home;


